import { Stack } from '@mui/joy';
import { Outlet, Route } from 'react-router-dom';

import { MobileLayout } from '../layout/MobileLayout';
import MNotFoundPage from '../pages/auth/mobile/MNotFoundPage';

import { createLazyRoute } from './utils/createLazyRoute';

/**
 * 모바일 관련 라우트
 */
export const mobileRoutes = (
  <>
    <Route path="m/create-subject" {...createLazyRoute(() => import('../pages/patient/MNewPatient'))} />
    {/* 토큰 검사 */}
    <Route path="m">
      {/* 배송, 처방 조회 */}
      <Route path="hm" {...createLazyRoute(() => import('../pages/home/MHomeRoot'))}>
        <Route path="delivery" {...createLazyRoute(() => import('../pages/home/MDeliveryRequestPage'))} />
        <Route path="delivery-status" {...createLazyRoute(() => import('../pages/home/MStimDeliveryStatusPage'))} />
        <Route path="return" {...createLazyRoute(() => import('../pages/home/MReturnRequestPage'))} />
        <Route path="return-status" {...createLazyRoute(() => import('../pages/home/MStimReturnStatusPage'))} />
        <Route path="change-address" {...createLazyRoute(() => import('../pages/home/MDeliveryChangeAddressPage'))} />
        <Route path="stim-diary" {...createLazyRoute(() => import('../pages/home/MStimDiaryRoot'))}>
          <Route index {...createLazyRoute(() => import('../pages/home/MStimDiaryHomePage'))} />
          <Route path="checkin" {...createLazyRoute(() => import('../pages/home/MStimCheckinPage'))} />
          <Route path="checkin-history" {...createLazyRoute(() => import('../pages/home/MStimCheckinHistoryPage'))} />
          <Route path="checkin-detail" {...createLazyRoute(() => import('../pages/home/MStimCheckinDetailPage'))} />
          <Route path="checkin-edit" {...createLazyRoute(() => import('../pages/home/MStimCheckinEditPage'))} />
          <Route path="settings" {...createLazyRoute(() => import('../pages/home/MStimSettingsPage'))} />
          <Route path="history" {...createLazyRoute(() => import('../pages/home/MStimServiceHistoryPage'))} />
          <Route
            path="history/detail"
            {...createLazyRoute(() => import('../pages/home/MStimServiceHistoryDetailPage'))}
          />
        </Route>
        <Route path="guide/stim-home" {...createLazyRoute(() => import('../pages/home/MStimUsageGuidePage'))} />
      </Route>

      {/* 카톡 링크 진입 → 채널톡 상담 창으로 리다이렉트. 토큰 검증 불필요, 독립 라우트로 둔다. */}
      <Route path="stim-home/channel-talk" {...createLazyRoute(() => import('../pages/home/MChannelTalkPage'))} />
    </Route>

    <Route path="m" element={<MobileLayout />}>
      <Route path="session" {...createLazyRoute(() => import('../pages/survey/MSurveySessionPage'))} />
      <Route path="agreement" {...createLazyRoute(() => import('../pages/patient/MServiceAgreementsPage'))} />
      <Route path="sleep-diary" {...createLazyRoute(() => import('../pages/sleep/MSleepDiaryPage'))} />

      {/* 배송 관련 페이지 — 상위 레이아웃에서 내 배송/배송지를 조회해 공유(DeliveryDataProvider). */}
      <Route {...createLazyRoute(() => import('../pages/delivery/MDeliveryLayout'))}>
        <Route path="delivery" {...createLazyRoute(() => import('../pages/home/MDeliveryRequestPage'))} />
        <Route path="delivery/status" {...createLazyRoute(() => import('../pages/delivery/MDeliveryStatusPage'))} />
        <Route path="delivery/return" {...createLazyRoute(() => import('../pages/home/MReturnRequestPage'))} />
        <Route
          path="delivery/return/status"
          {...createLazyRoute(() => import('../pages/delivery/MReturnStatusPage'))}
        />
        <Route
          path="delivery/change-address"
          {...createLazyRoute(() => import('../pages/home/MDeliveryChangeAddressPage'))}
        />
      </Route>
      <Route path="guide/scan-mini" {...createLazyRoute(() => import('../pages/delivery/MScanMiniUsageGuidePage'))} />
      <Route path="guide/stim-home" {...createLazyRoute(() => import('../pages/home/MStimUsageGuidePage'))} />
      <Route path="*" element={<MNotFoundPage />} />
    </Route>

    <Route path="phr" {...createLazyRoute(() => import('../pages/auth/mobile/MExpiredLegacySession'))} />
  </>
);
